import { type ISpotlightCollection } from '@pcln/contentful-components'
import analytics from '@/shared-utils/analytics'

export default function mapSpotlightCollectionData(
  collection: ISpotlightCollection
) {
  if (!Array.isArray(collection.mediaCards) || !collection.mediaCards.length) {
    return collection
  }

  const mappedMediaCards = collection.mediaCards.map(card => {
    if (card.callToAction?.analyticsTracking?.parameters) {
      return {
        ...card,
        callToAction: {
          ...card.callToAction,
          onClick: () => {
            analytics.fireGA4Event(
              card.callToAction.analyticsTracking.parameters
            )
          }
        }
      }
    }
    return card
  })

  return {
    ...collection,
    mediaCards: mappedMediaCards
  }
}
